import { AfterViewInit, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { ErrorDialog } from '../../../ui/dialog/error/error.dialog';
import {
    GetAppropriatenessClientUseCase,
    GetClientUseCase,
    GetContractUseCase,
    UpdateValidationUseCase,
    ValidateContractOnlyUseCase,
} from '../../../../core';
import { Id } from '../../../domain/data';
import { LocalStorage } from '../../../client/helpers/local-storage';
import { MainRoutes } from '../../../main-routes.enum';
import { ParentEvents } from '../../../utils/parent-events.service';
import { RepeatTestPage } from '../repeat-test.page';
import { TestResultSuitabilityPage } from '../../test/result-suitability/test-result-suitability.page';

@Component({
    templateUrl: './repeat-test-result-suitability.page.html',
    styleUrls: ['../../test/result-suitability/test-result-suitability.page.scss'],
})
export class RepeatTestResultSuitabilityPage extends TestResultSuitabilityPage implements AfterViewInit, OnInit {
    constructor(
        parentEvents: ParentEvents,
        repeatTestPage: RepeatTestPage,
        dialog: MatDialog,
        getAppropriatenessClientUseCase: GetAppropriatenessClientUseCase,
        getContractUseCase: GetContractUseCase,
        router: Router,
        updateValidationUseCase: UpdateValidationUseCase,
        validateContractOnlyUseCase: ValidateContractOnlyUseCase,
        private getClientUseCase: GetClientUseCase,
        private localStorage: LocalStorage
    ) {
        super(
            parentEvents,
            repeatTestPage,
            dialog,
            getAppropriatenessClientUseCase,
            getContractUseCase,
            router,
            updateValidationUseCase,
            validateContractOnlyUseCase
        );
    }

    protected getProfileName() {
        if (this.localStorage.clientCode) {
            this.getClientUseCase.bind({ code: Id.fromString(this.localStorage.clientCode) }).subscribe((transaction) => {
                transaction.fold(
                    (client) => {
                        this.profileName = client.profileName;
                        this.checkCompatibility(client);
                    },
                    (err) =>
                        this.dialog.open(ErrorDialog, {
                            data: { text: err.message },
                        })
                );
            });
        } else {
            this.parentEvents.cancel();
        }
    }

    onClick() {
        this.router.navigateByUrl(MainRoutes.REPEAT_TEST_SIGN + '?suitability=1');
    }
}
